"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _debug = _interopRequireDefault(require("debug"));

var _browserOrNode = require("browser-or-node");

var _config = require("../config");

var _v = _interopRequireDefault(require("uuid/v4"));

var _MewConnectCommon = _interopRequireDefault(require("../MewConnectCommon"));

var _MewConnectCrypto = _interopRequireDefault(require("../MewConnectCrypto"));

var _MewConnectInitiatorV = _interopRequireDefault(require("./MewConnectInitiatorV2"));

var _MewConnectInitiatorV2 = _interopRequireDefault(require("./MewConnectInitiatorV1"));

var _popUpCreator = _interopRequireDefault(require("../../connectWindow/popUpCreator"));

var _index = _interopRequireDefault(require("../../connectProvider/web3Provider/MEWconnect/index"));

var _popUpHandler = _interopRequireDefault(require("../../connectWindow/popUpHandler"));

var _WebRtcCommunication = _interopRequireDefault(require("../WebRtcCommunication"));

var _config2 = require("../../config");

var _package = _interopRequireDefault(require("../../../package.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const debug = (0, _debug.default)('MEWconnect:initiator-base');
const debugStages = (0, _debug.default)('MEWconnect:initiator-stages');
const debugConnectionState = (0, _debug.default)('MEWconnect:connection-state');
let qrString;

class MewConnectInitiator extends _MewConnectCommon.default {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super(options.version);
    this.optionVersion = options.version || 2.0;
    this.showPopup = options.showPopup || false;

    try {
      this.supportedBrowser = _MewConnectCommon.default.checkBrowser();
      this.requestIds = [];
      this.V1 = {};
      this.V2 = {};
      this.activePeerId = '';
      this.allPeerIds = [];
      this.peersCreated = [];
      this.v1Url = options.v1Url || _config.V1endpoint;
      this.v2Url = options.v2Url || _config.V2endpoint;
      this.turnTest = options.turnTest;
      this.destroyOnUnload(typeof window !== 'undefined');
      this.p = null;
      this.socketV2Connected = false;
      this.socketV1Connected = false;
      this.showingQR = false;
      this.connected = false;
      this.tryingTurn = false;
      this.turnDisabled = false;
      this.signalUrl = null;
      this.iceState = '';
      this.turnServers = [];
      this.refreshDelay = 20000;
      this.socketsCreated = false;
      this.refreshCount = 0;
      this.abandonedTimeout = 300000;
      this.showingRefresh = false;
      this.mewCrypto = options.cryptoImpl || _MewConnectCrypto.default.create();
      this.webRtcCommunication = new _WebRtcCommunication.default(this.mewCrypto);
      this.popupCreator = options.popupCreator ? options.popupCreator : options.newPopupCreator ? new _popUpCreator.default() : undefined;
      debugConnectionState('Initial Connection State:', MewConnectInitiator.getConnectionState());
      this.version = this.jsonDetails.version;
      this.lifeCycle = this.jsonDetails.lifeCycle;
      this.iceStates = this.jsonDetails.iceConnectionState;
      this.stunServers = options.stunServers || this.jsonDetails.stunSrvers; // Socket is abandoned.  disconnect.

      this.timer = null;
      setTimeout(() => {
        if (this.socket) {
          this.socketDisconnect();
        }
      }, this.abandonedTimeout);
      console.log("Using MEWconnect v".concat(_package.default.version));
    } catch (e) {
      debug('constructor error:', e);
    }
  }

  static setConnectionState(connectionState) {
    if (!connectionState) MewConnectInitiator.connectionState = _config2.DISCONNECTED;else MewConnectInitiator.connectionState = connectionState;
  }

  static getConnectionState() {
    if (!MewConnectInitiator.connectionState) return _config2.DISCONNECTED;
    return MewConnectInitiator.connectionState;
  }

  async createWalletOnly(network) {
    this.popUpHandler = new _popUpHandler.default();
    return (0, _index.default)({
      network
    }, this.popupCreator, this.popUpHandler);
  }

  isAlive() {
    if (this.p !== null) {
      return this.p.connected && !this.p.destroyed;
    }

    return false;
  }

  focusPopupWindow() {
    if (!this.popupCreator) return;

    if (this.popupCreator.popupWindowOpen) {
      this.popupCreator.popupWindow.focus();
    }
  } // Check if a WebRTC connection exists before a window/tab is closed or refreshed
  // Destroy the connection if one exists


  destroyOnUnload() {
    if (_browserOrNode.isBrowser) {
      try {
        // eslint-disable-next-line no-undef
        if (!window) return; // eslint-disable-next-line no-undef

        window.onunload = window.onbeforeunload = () => {
          const iceStates = [this.iceStates.new, this.iceStates.connecting, this.iceStates.connected];

          if (this.Peer) {
            if (!this.Peer.destroyed || iceStates.includes(this.iceState)) {
              this.rtcDestroy();
            }
          }

          if (this.popupCreator) {
            this.popupCreator.removeWindowClosedListener();
            this.popupCreator.closePopupWindow();
          }
        };
      } catch (e) {
        debug(e);
      }
    }
  }

  static checkBrowser() {
    return _MewConnectCommon.default.checkBrowser();
  }

  static checkWebRTCAvailable() {
    return _MewConnectCommon.default.checkWebRTCAvailable();
  } // Returns a boolean indicating whether the socket connection exists and is active


  getSocketConnectionState() {
    return this.socketV1Connected || this.socketV2Connected;
  } // Returns a boolean indicating whether the WebRTC connection exists and is active


  getConnectonState() {
    return this.connected;
  } // can be used to listen to specific events, especially those that pass data


  uiCommunicator(event, data) {
    debug('MewConnectInitiator event emitted', event);
    this.emit(event, data);
    this.emitStatus(event);
  } // special status emitter to allow simple listening of various statuses in one listener


  emitStatus(event) {
    this.emit('status', event);
  } // Emit/Provide the details used in creating the QR Code


  displayCode(privateKey) {
    try {
      if (privateKey instanceof Buffer) {
        privateKey = privateKey.toString('hex');
      }

      let dapp = 'example';

      if (typeof window !== 'undefined') {
        dapp = window.location.hostname;
      }

      debug('handshake', privateKey);
      this.socketKey = privateKey;
      const separator = this.jsonDetails.connectionCodeSeparator;
      let qrCodeString = this.version + separator + privateKey + separator + this.connId + ':name=' + dapp.replace(/^www\./, '');

      if (dapp.includes('myetherwallet.com')) {
        qrCodeString = this.version + separator + privateKey + separator + this.connId;
      } else if (dapp.includes('mewbuilds.com')) {
        qrCodeString = this.version + separator + privateKey + separator + this.connId;
      } else if (dapp.includes('localhost')) {
        qrCodeString = this.version + separator + privateKey + separator + this.connId;
      }

      qrString = qrCodeString;

      const unloadOrClosed = () => {
        if (!this.connected) {
          // eslint-disable-next-line no-console
          debug('popup window closed');
          this.uiCommunicator('popup_window_closed');
          MewConnectInitiator.setConnectionState();
          this.socketDisconnect();
          this.emit(this.lifeCycle.AuthRejected);
        }
      };

      debug(qrCodeString);
    } catch (e) {
      debug('displayCode error:', e);
    }
  }

  ShowQr(qrCodeString) {
    const unloadOrClosed = () => {
      if (!this.connected) {
        // eslint-disable-next-line no-console
        debug('popup window closed');
        this.uiCommunicator('popup_window_closed');
        MewConnectInitiator.setConnectionState();
        this.socketDisconnect();
        this.emit(this.lifeCycle.AuthRejected);
      }
    };

    debug(qrCodeString);

    if (this.showPopup) {
      if (this.popupCreator.popupWindowOpen) {
        if (this.popupCreator) this.popupCreator.updateQrCode(qrCodeString);
      } else {
        if (this.popupCreator) this.popupCreator.refreshQrcode = this.initiatorStart.bind(this);
        this.popupCreator.openPopupWindow(qrCodeString);
        if (this.popupCreator) this.popupCreator.container.addEventListener('mewModalClosed', unloadOrClosed, {
          once: true
        });
      }
    } else {
      this.uiCommunicator(this.lifeCycle.codeDisplay, qrCodeString); // this.uiCommunicator(this.lifeCycle.checkNumber, privateKey);

      this.uiCommunicator(this.lifeCycle.ConnectionId, this.connId);
    }
  }
  /*
  ===================================================================================
  Keys
  ===================================================================================
  */

  /* Set the public and private keys, connId, and signed that will be used
   * for the duration of the pairing process. The receiver will need to have access
   * to this information as well, however, the initiator creates the credentials to be
   * shared with the receiver.
   */


  generateKeys(testPrivate) {
    if (!this.mewCrypto) this.mewCrypto = _MewConnectCrypto.default.create();
    let keys = {};

    if (testPrivate) {
      keys = this.mewCrypto.setPrivate(testPrivate);
    } else {
      keys = this.mewCrypto.generateKeys();
    }

    this.publicKey = keys.publicKey;
    this.privateKey = keys.privateKey;
    this.connId = this.mewCrypto.generateConnId(this.publicKey);
    this.signed = this.mewCrypto.signMessageSync(this.privateKey, this.privateKey);
    debug('this.signed', this.signed);
  }

  async refreshCode() {
    // this.showingRefresh = false;
    const v2Events = ['sendingOffer', 'retryingViaTurn', 'socketDisconnected', 'socketPaired'];
    const webRtcCommEvents = ['disconnected', 'data', 'UsingFallback', 'showRefresh', 'decryptError', 'RtcConnectedEvent', 'signal']; // "sendingOffer", "retryingViaTurn", "socketDisconnected", "socketPaired"
    // "disconnected", "data", "UsingFallback", "showRefresh", "decryptError", "RtcConnectedEvent", "signal"

    webRtcCommEvents.forEach(event => this.webRtcCommunication.removeAllListeners(event));
    v2Events.forEach(event => this.V2.removeAllListeners(event));
    this.V2.socketDisconnect();
    if (this.popupCreator) this.popupCreator.popupWindowOpen = true;
    this.webRtcCommunication = new _WebRtcCommunication.default(this.mewCrypto);
    this.initiatorStart();
  } // TODO change this to use supplied urls at time point


  async initiatorStart(url, testPrivate) {
    if (this.socketV1Connected) {
      this.V1.socketDisconnect();
    }

    if (this.socketV2Connected) {
      this.V2.socketDisconnect();
    }

    this.generateKeys(testPrivate);
    this.displayCode(this.privateKey);
    this.webRtcCommunication.once(this.lifeCycle.disconnected, this.uiCommunicator.bind(this, this.lifeCycle.RtcClosedEvent));
    const options = {
      stunServers: this.stunServers,
      turnTest: this.turnTest,
      version: this.optionVersion,
      uiCommunicator: this.uiCommunicator.bind(this),
      webRtcCommunication: this.webRtcCommunication,
      crypto: this.mewCrypto
    };
    this.webRtcCommunication.on('data', this.dataReceived.bind(this));

    try {
      this.V2 = new _MewConnectInitiatorV.default(_objectSpread({
        url: _config.V2endpoint
      }, options));
      await this.V2.initiatorStart(_config.V2endpoint, this.mewCrypto, {
        signed: this.signed,
        connId: this.connId
      });
      this.V2.on('sendingOffer', () => {
        if (this.popupCreator) this.popupCreator.showConnecting();
      });
      this.V2.on('retryingViaTurn', () => {
        this.showingRefresh = false; // reset refresh
      });

      const regenerateQRcodeOnClick = () => {
        debug('REGENERATE');
        this.refreshCode();
      };

      const showRefresh = () => {
        if (!this.connected) {
          if (!this.showingRefresh) {
            this.showingRefresh = true; // only process one refresh event

            if (this.popupCreator) this.popupCreator.showRetry(regenerateQRcodeOnClick);
          }
        }
      };

      this.V2.on('socketDisconnected', showRefresh.bind(this));
      this.V2.on('showRefresh', showRefresh.bind(this));
      this.webRtcCommunication.on('showRefresh', showRefresh.bind(this));
      this.webRtcCommunication.on(this.lifeCycle.decryptError, () => {
        if (this.webRtcCommunication.initialAddressRequest !== 'complete') {
          MewConnectInitiator.setConnectionState(_config2.DISCONNECTED);
          this.webRtcCommunication.rtcDestroy();
        }
      });
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
      this.V2 = null;
    }

    try {
      this.V1 = new _MewConnectInitiatorV2.default(_objectSpread({
        url: _config.V1endpoint
      }, options));
      await this.V1.initiatorStart(_config.V1endpoint, this.mewCrypto, {
        signed: this.signed,
        connId: this.connId
      });
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
      this.V1 = {};
    }

    if (!this.V2) {} // this.ShowQr(qrString);


    this.webRtcCommunication.setActiveInitiatorId(this.V2.initiatorId);
    const connectionErrorTimeOut = setTimeout(() => {
      window.alert('Failed to start MEWconnect. Please try again.');
    }, 60000);

    if (this.V1.on) {
      this.V1.on('socketPaired', () => {
        if (this.V2.socketDisconnect) this.V2.socketDisconnect();
        this.socketV1Connected = true;
      });
      this.V1.once('SOCKET_CONNECTED', () => {
        if (!this.showingQR) {
          clearTimeout(connectionErrorTimeOut);
          this.showingQR = true;
          this.ShowQr(qrString);
        }
      });
    }

    if (this.V2.on) {
      this.V2.on('socketPaired', () => {
        if (this.V1.socketDisconnect) this.V1.socketDisconnect();
        this.socketV2Connected = true;
      });
      this.V2.once('SOCKET_CONNECTED', () => {
        if (!this.showingQR) {
          clearTimeout(connectionErrorTimeOut);
          this.showingQR = true;
          this.ShowQr(qrString);
        }
      });
    }

    this.webRtcCommunication.once(this.jsonDetails.lifeCycle.RtcConnectedEvent, peerid => {
      this.webRtcCommunication.removeAllListeners(this.jsonDetails.lifeCycle.RtcConnectedEvent);
      debug('RTC CONNECTED ENVIRONMENT SETUP');
      this.emit(this.lifeCycle.RtcConnectedEvent);
      this.webRtcCommunication.on('appData', this.dataReceived.bind(this));
      this.connected = true;
      if (this.popupCreator) this.popupCreator.removeWindowClosedListener();
      if (this.popupCreator) this.popupCreator.closePopupWindow();
      MewConnectInitiator.setConnectionState(_config2.CONNECTED);
    });
  }

  socketDisconnect() {
    this.V2.socketDisconnect();
    this.V1.socketDisconnect();
  }

  disconnectRTC() {
    if (this.connected) {
      debugStages('DISCONNECT RTC');
      this.uiCommunicator(this.lifeCycle.RtcDisconnectEvent);
      this.webRtcCommunication.disconnectRTC();
      this.connected = false;
      this.instance = null;
    }
  }

  async rtcSend(arg) {
    await this.webRtcCommunication.rtcSend(arg);
  }

  sendRtcMessage(type, data) {
    const id = (0, _v.default)();
    this.requestIds.push(id);
    debug('MESSAGE IDS KNOWN', this.requestIds);
    this.webRtcCommunication.sendRtcMessage(type, data, id);
  }

  dataReceived(data) {
    debug('dataReceived', data); // this.webRtcCommunication.once('appData', this.dataReceived.bind(this));

    if (data.id) {
      debug('MESSAGE ID RECEIVED', data.id);

      if (this.requestIds.includes(data.id)) {
        this.uiCommunicator(data.type, data.data);
        const idx = this.requestIds.findIndex(item => item === id);
        this.requestIds.splice(idx, 1);
        debug('MESSAGE IDS KNOWN', this.requestIds);
      } else {
        debug('**NO MESSAGE ID RECEIVED : field present**');
        this.uiCommunicator(data.type, data.data);
      }
    } else {
      debug('**NO MESSAGE ID RECEIVED : field absent**');
      this.uiCommunicator(data.type, data.data);
    }
  }

  testV1Turn() {
    this.V1.disconnectRTC();
  }

  testV2Turn() {
    this.V2.disconnectRTC();
    this.V2.emit(this.lifeCycle);
  }

}

exports.default = MewConnectInitiator;